// extracted by mini-css-extract-plugin
export default {"container":"columns_container__1gK2L","cols":"columns_cols__TejJw","col":"columns_col__3utrl","item":"columns_item__1nPRK","spacer":"columns_spacer__2yttl"};